<template>
    <div class="fields-selection-step d-flex flex-column">
        <div class="fields-selection-step__scroll">
            <CheckboxCardList
                :items="items"
                :model-value="selectedKeys"
                select-all
                @update:model-value="updateSelected"
            />
        </div>
    </div>
</template>
<script>
import CheckboxCardList from '../../../../components/new/card/CheckboxCardList.vue';

export default {
    name: "FieldsSelectionComponent",
    components: {
        CheckboxCardList
    },
    props: {
        fieldsWhoCanBeMapped: {
            type: Array,
            required: true,
        },
    },
    methods: {
        updateSelected(keys) {
            this.fieldsWhoCanBeMapped.forEach(field => {
                field.selected = field.key === 'names' || keys.includes(field.key);
            });
        },
    },
    computed: {
        items() {
            return this.fieldsWhoCanBeMapped.map(field => ({
                value: field.key,
                label: field.label,
                disabled: field.key === 'names',
            }));
        },
        selectedKeys() {
            return this.fieldsWhoCanBeMapped.filter(field => field.selected).map(field => field.key);
        },
    }
}
</script>
<style scoped>
.fields-selection-step {
    height: 100%;
}

.fields-selection-step__scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}
</style>
